import styled from "styled-components";

export default styled.input`
    width: auto !important;
`;
